<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Security",
    "pageDesc":"Secure your online solutions and protect it against potential attacks with advanced security practices.",
    "mantra":"Integrated security |solutions.",
    "sec1Items":{
      "1":{
        "title":"Email security",
        "desc":"Keep your emails clean from junk and protect your valuable business information and clients’ privacy through continuous scan for viruses, malwares and malicious attacks."
      },
      "2":{
        "title":"Endpoint security ",
        "desc":"From threat identification until the breach is revealed, our solutions protect you from planned cyber-attacks by monitoring and securing every end point"
      },
      "3":{
        "title":"Mobile security",
        "desc":"Allow only authorized devices to access your data and use multi-layer protection to continually scan devices for malwares, prevent potential data leaks and detect vulnerabilities"
      }
    },
    "sec2":"We believe everything online needs protection.",
    "sec2Items":{
      "1":{
        "title":"Innovate freely",
        "desc":"Write code and implement features without the fear of external threats. Have a friendly web or mobile app that is secure and reliable."
      },
      "2":{
        "title":"Protect your organization",
        "desc":"Leaks could damage your business reputation, especially when it comes to customer data. Secure your business sensitive information from outside attacks. "
      }
    },
    "cta":"Secure your online <br> business. "
  },
  "ar": {
    "pageTitle":"حماية وأمان البرمجيات",
    "pageDesc":"اعمل على حماية حلولك البرمجية من الهجمات الضارة والخبيثة من خلال الممارسات الأمان التي نوفرها لك مهما كانت احتياجاتك.",
    "mantra":"حماية وأمان البرمجيات |للمزيد من الابتكار.",
    "sec1Items":{
      "1":{
        "title":"حماية البريد",
        "desc":"حافظ على رسائلك محمية، وكذلك معلوماتك التجارية، وخصوصية العملاء من خلال الفحص المستمر للفيروسات والبرامج الضارة والهجمات الخبيثة."
      },
      "2":{
        "title":"حماية الأجهزة الطرفية ",
        "desc":"تحميك حلولنا من هجمات الانترنت من خلال مراقبتنا وتأميننا لكافة الأجهزة الطرفية. وبذلك نوفر عليك الكثير من الوقت الضائع في التعرف على التهديدات ومحاولات الاختراق."
      },
      "3":{
        "title":"التحقُّق بخطوتين",
        "desc":"السماح للأجهزة المُصرح بها فقط للوصول إلى بياناتك الخاصة واستخدام الحماية مُتعددة الطبقات لفحص الأجهزة بشكل مستمر للبرامج الضارة. ومنع تسريب البيانات المحتملة واكتشاف نقاط الضعف."
      }
    },
    "sec2":"نؤمن أن أي شيء على الإنترنت يحتاج إلى حماية.",
    "sec2Items":{
      "1":{
        "title":"ابتكر بحرية",
        "desc":"يمكنك كتابة الكود وتطبيق المميزات دون التفكير في أي هجمات أو الخوف من التهديدات الخارجية. احصل على تطبيق الموقع أو الجوال يتمتع بأمان وحماية كاملة."
      },
      "2":{
        "title":"أمن على مؤسستك",
        "desc":"قد تتسبب التسريبات في تلف سمعتك عملك، خاصة عندما يتعلق الأمر ببيانات عملائك. آمن على المعلومات الهامة والحساسة من أضرار الهجمات الخارجية. "
      }
    },
    "cta":"أمن على أعمالك الآن."
  }
}
</i18n>
